var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragRowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 22,
    viewBox: "0 0 8 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.15527,
    cy: 1.25,
    r: 1.08594,
    fill: "#404040"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.79688,
    cy: 1.25,
    r: 1.08594,
    fill: "#404040"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.15527,
    cy: 6,
    r: 1.08594,
    fill: "#404040"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.79688,
    cy: 6,
    r: 1.08594,
    fill: "#404040"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.15527,
    cy: 10.75,
    r: 1.08594,
    fill: "#404040"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.79688,
    cy: 10.75,
    r: 1.08594,
    fill: "#404040"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.15527,
    cy: 15.5,
    r: 1.08594,
    fill: "#404040"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.79688,
    cy: 15.5,
    r: 1.08594,
    fill: "#404040"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.15527,
    cy: 20.25,
    r: 1.08594,
    fill: "#404040"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.79688,
    cy: 20.25,
    r: 1.08594,
    fill: "#404040"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragRowIcon);
export default __webpack_public_path__ + "static/media/dragRowIcon.2ada8af1c2c7c424312c1f52861cc041.svg";
export { ForwardRef as ReactComponent };